import React, { FC, useEffect, useState } from 'react';
import CustomerNavigation from './CustomerNavigation';
import useSite from 'src/hooks/api/useSite';
import { ContactsContextProvider } from '../../hooks/useContacts';
import Site from '../../../../../interfaces/api/Site';

interface Props {
  loading: boolean;
  openModal: Function;
  customerId: any;
  customerContacts: any;
  customerTickets: any;
  customerSubOffices: any;
  customerDeals: any;
  customerExternalContacts: any;
}

const CustomerNavigationContainer: FC<Props> = ({ ...props }) => {
  const [site, setSite] = useState<Site | undefined>();
  const [, setSiteLoading] = useState(false);
  const [, setError] = useState<string>();

  const { getSiteOfLegacyCustomer } = useSite();

  useEffect(() => {
    if (props.customerId) {
      setSiteLoading(true);

      getSiteOfLegacyCustomer(props.customerId)
        .then((site) => {
          setSite(site);
          setSiteLoading(false);
        })
        .catch((e) => {
          setSite(undefined);
          setError(e.message || 'erreur');
          setSiteLoading(false);
        });
    }
  }, [props.customerId]);

  return (
    <ContactsContextProvider siteId={site?.id}>
      <CustomerNavigation site={site} {...props} />
    </ContactsContextProvider>
  );
};

export default CustomerNavigationContainer;
